import GetErrorMessageMixin from '../helpers/get_error_message';

export default {
    mixins: [GetErrorMessageMixin],

    computed: {
        errorType() {
            if (!this.error) {
                return {};
            }

            if (!this.ERRORS_TYPES) {
                return { main: true };
            }

            const errorsTypes = Object.entries(this.ERRORS_TYPES).reduce(
                (errorTypes, [errorTypeName, errors]) => Object.assign(errorTypes, {
                    [errorTypeName]: errors.some(error => this.errors.includes(error)),
                }),
                {},
            );

            const isAnyErrorsTypes = Object.values(errorsTypes).some(Boolean);

            if (isAnyErrorsTypes) {
                return errorsTypes;
            }

            return { main: true };
        },

        errorsTemplates() {
            if (this.errorType.main) {
                return {
                    main: this.getErrorMessage(this.errors[0], null, 'js-tmpl-errors-process_error'),
                };
            }

            const errorsTemplates = Object.entries(this.errorType).reduce(
                (templates, [errorType, isErrorActive]) => {
                    if (this.ERRORS_TYPES[errorType] && isErrorActive) {
                        // eslint-disable-next-line max-len
                        const error = this.ERRORS_TYPES[errorType].find(err => this.errors.includes(err));

                        const errorTemplate = this.getErrorMessage(error);

                        const updatedTemplates = Object.assign(templates, {
                            [errorType]: errorTemplate,
                        });

                        return updatedTemplates;
                    }

                    return templates;
                },
                {},
            );

            return errorsTemplates;
        },
    },
};
